import React, { Component } from 'react';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import RegisterWarehouseUser from 'components/modules/settings/RegisterWarehouseUser';
import Container from '../../v2/container';
import AdminUsersList from './AdminUsersList';
import RegisterDriver from './RegisterDriver';
import RegisterShipper from './RegisterShipper';
import RegisterCarrier from './RegisterCarrier';
import RegisterVendor from './RegisterVendor';
import RegisterConsignee from './RegisterConsignee';
import VerticalNav from '../../v2/navs/VerticalNav';
import BulkRegisterUsers from './BulkRegisterUsers';
const navItems = _.sortBy([
    {
        text: 'Admin',
        component: React.createElement(AdminUsersList, null),
        slug: 'admin',
        localizationSlug: 'ADMIN',
    },
    {
        text: 'Driver',
        component: React.createElement(RegisterDriver, null),
        slug: 'register_driver',
        localizationSlug: 'DRIVER',
    },
    {
        text: 'Shipper',
        component: React.createElement(RegisterShipper, null),
        slug: 'register_shipper',
        localizationSlug: 'SHIPPER',
    },
    {
        text: 'Carrier',
        component: React.createElement(RegisterCarrier, null),
        slug: 'register_carrier',
        localizationSlug: 'CARRIER',
    },
    {
        text: 'Vendor',
        component: React.createElement(RegisterVendor, null),
        slug: 'register_vendor',
        localizationSlug: 'VENDOR',
        count: 1,
    },
    {
        text: 'Consignee',
        component: React.createElement(RegisterConsignee, null),
        slug: 'register_consignee',
        localizationSlug: 'CONSIGNEE',
        count: 1,
    },
    {
        text: 'Warehouse User',
        component: React.createElement(RegisterWarehouseUser, null),
        slug: 'register_warehouse_user',
        localizationSlug: 'WAREHOUSE_USER',
    },
    {
        text: 'Bulk Register Users',
        component: React.createElement(BulkRegisterUsers, null),
        slug: 'bulk_register_users',
        localizationSlug: 'BULK_REGISTER_USERS',
    },
], 'text');
class Settings extends Component {
    constructor(props) {
        super(props);
        this.handleNavItemClick = (activePage) => () => {
            this.setState({ activePage });
        };
        this.getNavItems = (slug = '') => {
            return [];
        };
        this.state = {
            activePage: 'admin',
        };
    }
    isActive(slug) {
        if (this.state.activePage === slug) {
            return true;
        }
        return false;
    }
    getActiveComponent() {
        const { activePage } = this.state;
        return navItems.find((n) => n.slug === activePage).component;
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Container, null,
            React.createElement("div", { className: "grid sm:grid-cols-12 gap-8 mt-10" },
                React.createElement("div", { className: "col-span-2" },
                    React.createElement(VerticalNav, null, navItems.map((navItem) => (React.createElement(AuthorizationWrapper, { excludedRegions: this.getNavItems(navItem.slug) },
                        React.createElement(VerticalNav.NavItem, { key: navItem.slug, onClick: this.handleNavItemClick(navItem.slug), active: this.isActive(navItem.slug), title: titleize(t(navItem.localizationSlug, { count: navItem.count })) }, titleize(t(navItem.localizationSlug, { count: navItem.count })))))))),
                React.createElement("div", { className: "col-span-10" }, this.getActiveComponent()))));
    }
}
export default withTranslation()(Settings);
